import { render, staticRenderFns } from "./InvitePlayerDialog.vue?vue&type=template&id=6486b5ea&"
import script from "./InvitePlayerDialog.vue?vue&type=script&lang=ts&"
export * from "./InvitePlayerDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports